import React from 'react';

import { useBusinessToolSessionStore } from 'store/useBusinessToolStore';
import { getBusinessToolMode } from 'store/useBusinessToolStore/selectors';

import { checkIsPreviewMode } from 'pages/BusinessToolPage/utils';

import { BottomNavigationButtonsMobile } from 'components/BottomNavigationButtonsMobile/BottomNavigationButtonsMobile';

import { ForInvestorsSectionNavigation } from './ForInvestorsSectionNavigation';
import { TNavigationRenderFn } from '../../../types';
import { ModeSwitch } from '../../ModeSwitch/ModeSwitch';
import { ViewExampleSwitch } from '../../ViewExampleSwitch';

interface IForInvestorNavigationProps {
  render: TNavigationRenderFn;
}

export const ForInvestorNavigation: React.FC<IForInvestorNavigationProps> = ({ render }) => {
  const businessToolMode = useBusinessToolSessionStore(getBusinessToolMode);
  const isPreviewMode = checkIsPreviewMode(businessToolMode);

  return render({
    modeSwitch: <ModeSwitch />,
    typeSwitch: isPreviewMode && <ViewExampleSwitch />,
    sectionsNavigation: <ForInvestorsSectionNavigation />,
    navigationButtons: <BottomNavigationButtonsMobile />,
  });
};
